import { useMemo } from 'react';
import { useAuth } from '@contexts/useAuth';
import type { Feature } from '@d-orca/shared/permissions';

const NONE: ReadonlySet<Feature> = new Set();

/** The features the signed-in user is granted; none while signed out. */
export function useFeatures(): ReadonlySet<Feature> {
  const { user } = useAuth();
  return useMemo(() => (user ? new Set(user.features) : NONE), [user]);
}

/** Whether the user may use `feature`. No feature means no gate. Not rendering
 *  UI with this is convenience only — the server enforces it. */
export function useCanAccess(feature?: Feature): boolean {
  const features = useFeatures();
  return !feature || features.has(feature);
}
